import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, DollarSign, Search, Users, User } from 'lucide-react';
import { useFeatures } from '../../contexts/FeatureContext';

export const BottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isFeatureEnabled } = useFeatures();

  const tabs = [
    { id: 'home', label: 'Home', icon: Home, path: '/app/home', alwaysShow: true },
    { id: 'finance', label: 'Finance', icon: DollarSign, path: '/app/finance', alwaysShow: true },
    { id: 'discover', label: 'Discover', icon: Search, path: '/app/discover', alwaysShow: true },
    { id: 'social', label: 'Social', icon: Users, path: '/app/social', feature: 'connect_feed' },
    { id: 'profile', label: 'Profile', icon: User, path: '/app/profile', alwaysShow: true },
  ];

  const isActive = (path) => location.pathname.startsWith(path);

  // Filter out tabs for disabled features
  const visibleTabs = tabs.filter(tab => {
    if (tab.alwaysShow) return true;
    if (tab.feature) return isFeatureEnabled(tab.feature);
    return true;
  });

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 z-50 safe-area-inset-bottom">
      <div className="flex items-center justify-around h-16 max-w-screen-xl mx-auto px-2">
        {visibleTabs.map((tab) => {
          const Icon = tab.icon;
          const active = isActive(tab.path);
          
          return (
            <button
              key={tab.id}
              onClick={() => navigate(tab.path)}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
                active
                  ? 'text-blue-600 dark:text-blue-400'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100'
              }`}
              data-testid={`bottom-nav-${tab.id}`}
            >
              <Icon className={`h-5 w-5 mb-1 ${active ? 'stroke-[2.5]' : 'stroke-2'}`} />
              <span className={`text-xs ${active ? 'font-semibold' : 'font-normal'}`}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
